// extracted by mini-css-extract-plugin
export default {"main":"CustomerOnboardingCards-module__main___0i3UC"};